__turbopack_context__.v({
  "dateChevron": "HeroSection-module__1olGuq__dateChevron",
  "dateDisplayText": "HeroSection-module__1olGuq__dateDisplayText",
  "dateIcon": "HeroSection-module__1olGuq__dateIcon",
  "dateInputNative": "HeroSection-module__1olGuq__dateInputNative",
  "dateInputWrapper": "HeroSection-module__1olGuq__dateInputWrapper",
  "dateLabel": "HeroSection-module__1olGuq__dateLabel",
  "dateWrapper": "HeroSection-module__1olGuq__dateWrapper",
  "dot": "HeroSection-module__1olGuq__dot",
  "dotActive": "HeroSection-module__1olGuq__dotActive",
  "dwCard": "HeroSection-module__1olGuq__dwCard",
  "dwCardActive": "HeroSection-module__1olGuq__dwCardActive",
  "dwCardHidden": "HeroSection-module__1olGuq__dwCardHidden",
  "dwCardNext": "HeroSection-module__1olGuq__dwCardNext",
  "dwCardPrev": "HeroSection-module__1olGuq__dwCardPrev",
  "dwCarousel": "HeroSection-module__1olGuq__dwCarousel",
  "dwContainer": "HeroSection-module__1olGuq__dwContainer",
  "dwDots": "HeroSection-module__1olGuq__dwDots",
  "dwSubtitle": "HeroSection-module__1olGuq__dwSubtitle",
  "dwTitle": "HeroSection-module__1olGuq__dwTitle",
  "featureCard": "HeroSection-module__1olGuq__featureCard",
  "featureGrid": "HeroSection-module__1olGuq__featureGrid",
  "heading": "HeroSection-module__1olGuq__heading",
  "heroContainer": "HeroSection-module__1olGuq__heroContainer",
  "inputContainer": "HeroSection-module__1olGuq__inputContainer",
  "slideIcon": "HeroSection-module__1olGuq__slideIcon",
  "startButton": "HeroSection-module__1olGuq__startButton",
  "subText": "HeroSection-module__1olGuq__subText",
});
